// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-actions[data-v-4a341e8c]{display:flex;justify-content:flex-end;align-items:center}", ""]);
// Exports
module.exports = exports;
